import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

//Importar componentes a renderizarse.
import Navigation from "../components/common/Navbar/Navigation.jsx";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/common/Sidebar/Sidebar.jsx";

//Importar componenete Cargando...
import Loading from "../components/common/Loading/Loading.jsx";

//Importar imágenes (logos).
import logoLPChat from "../assets/images/logo-lpachat-grey.png";

//Importar helpers.
import { iconSidebar } from "../helpers/iconSidebar.js";
import { connectSocket, disconnectSocket, getSocket } from "../config/socket.js";
import ModalMessageResolutions from "../components/common/Modal/ModalMessageResolutions.jsx";
import useDisconnectSocket from "../hooks/useDisconnectSocket.js";

const Inicio = ({ ruta, onChangeRuta, setSocketConnected }) => {

  const [showContent, setShowContent] = useState(false); //Estado para mostrar el contenido luego del Time Out para el Caraando...
  const navigate = useNavigate();
  const [icon, setIcon] = useState({}); //Estado para actualizar el objeto con los íconos que debe tener el sideBar.
  const [rutaVisitada, setRutaVisitada] = useState(localStorage.getItem('rutaEnSesion') || '');

  const onChangeIcons = (iconsList) => { //Función para setear el estado "icon" con la lista de íconos.
    setIcon(iconsList);
  };

  //FUNCIONES PARA MANEJO DE RUTAS
  const savedRuta = () => { //Función para almacenar la ruta actual bajo el nombre de ruta en sesión.
    if (ruta !== '') {
      localStorage.setItem('rutaEnSesion', ruta);
    };
  };
  const getRuta = () => { //Función para optener la ruta en sesión desde el localStorage.
    let ruta = localStorage.getItem('rutaEnSesion');
    if (ruta !== '') setRutaVisitada(ruta)
  };
  useEffect(() => { //Se ejecuta al renderizar el componente.
    savedRuta();
    getRuta();
    onChangeRuta(rutaVisitada);
    let iconsList = iconSidebar(); //Extraer el objeto con los íconos que debe tener el sidebar.
    onChangeIcons(iconsList); //Llamar a la función callback que actualiza la lista de íconos.
    navigate('Chats', { replace: true }); //Redireccionar a "Chats".
  }, []);

  useEffect(() => { //Se ejecuta para mostrar el logo de LPChat con el cargando...
    setTimeout(() => {
      setShowContent(true); // Muestra el contenido de la página de inicio pasado el cargando...
    }, 2000); // 1000 ms = 1 segundo
  }, []);


  useEffect(() => { //Funcion para ejecutar al renderizarse el componente para conectarse al socket.
    connectSocket(); //Ejecutar la función para conectar el socket.
    let socket = getSocket(); //Extraer el socket de conexión.
    if (socket) { //Si existe el socket de conexión.
      socket.on("connect_error", (data) => { setSocketConnected(false); console.log("error al conectar el socket", data) });
      if (getSocket ()) setSocketConnected(true)
    } else {
      disconnectSocket();
    }
  }, []);

  useDisconnectSocket();

  return (
    <>
      {/*------------Contenido que se muestra en el Cargando..... */}
      {!showContent &&
        <>
          <div className="container-login__loading">
            <img src={logoLPChat} className="logo-small" alt="LPChat"></img>
            <Loading setSocketConnected = {setSocketConnected} />
          </div>
        </>}
      {/*----Modal con el mensaje de las resoluciones---*/}
      {showContent && <ModalMessageResolutions />}

      {/*----Barra de Navegación Lateral, que recibe como prop el objeto con los íconos
        que debe tener y el color seleccionado como tema de la aplicación --------*/ }
      {showContent && <Sidebar permisos={icon} />}

      {showContent && <div className="container-inicio__layout" >

        {/*----Barra de Navegación de Empresas, que recibe como prop la función de callback
        para setear el estado que contiene los íconos del sidebar, y el color seleccionado
        como tema de la aplicación---------------*/ }
        <Navigation onChangeIcons={onChangeIcons} />

        {/*-----Espacio reservado par la barra lateral dentro del layout de inicio---------*/}
        <div className="container-sidebar" ></div>

        <section className="container-inicio__outletSection-layout">
          <Outlet />
        </section>
      </div>}
    </>
  )
};

export default Inicio;